import React, { useState, useContext } from 'react'
import { Col, Input, Row, Button, Card, Label } from 'reactstrap'
import { LiveProdName, NewsLetterStyle } from '../../../../StyledComponents'
import Rating from 'react-rating'
import { Star } from 'react-feather'
import { ThemeColors } from '@src/utility/context/ThemeColors'
import { IoCaretBackOutline } from 'react-icons/io5'
import ImageFileUploader from '../../../Manage/ImageFileUploader'

const ProductReviewForm = (props) => {

    const { onCancel } = props;

    const themeColors = useContext(ThemeColors)
    const [selectedRating, setSelectedRating] = useState(null)
    const [pictures, setPictures] = useState([])
    const [imgs, setImgs] = useState([])
    const [videos, setVideos] = useState([])
    const [videoFiles, setVideoFiles] = useState([])
    const [reviewText, setReviewText] = useState('')

    const ratingOptions = ['5', '4', '3', '2', '1']

    const handleRatingChange = (rating) => {
        setSelectedRating(rating)
    }

    const handleRemoveFile = (index, type) => {
        if (type === 'image') {
            const updatedImgs = imgs.filter((_, i) => i !== index)
            setImgs(updatedImgs)

            const updatedPictures = pictures.filter((_, i) => i !== index)
            setPictures(updatedPictures)
        } else if (type === 'video') {
            const updatedVideos = videos.filter((_, i) => i !== index)
            setVideos(updatedVideos)

            const updatedVideoFiles = videoFiles.filter((_, i) => i !== index)
            setVideoFiles(updatedVideoFiles)
        }
    }

    const onSubmit = () => {
        const formData = {
            rating: selectedRating,
            review: reviewText,
            pictures: pictures,
            videos: videos
        }
        console.log('Form Data:', formData)
    }

    return (
        <div>
            <Row>
                <Col xl='1' lg='1' md='1' sm='12' xs='12'>
                    <NewsLetterStyle style={{ fontSize: '18px', cursor: 'pointer' }} onClick={() => onCancel(false)}> <IoCaretBackOutline /> Back</NewsLetterStyle>
                </Col>
                <Col xl='11' lg='11' md='11' sm='12' xs='12'>
                <div >
                    <Row style={{display:'flex', justifyContent:'center'}}>
                        <Col xl='7' lg='7' md='12' sm='12' xs='12'>
                        <Card className='py-4' style={{border:'none'}}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between', marginBottom:'1rem' }}>
                                <NewsLetterStyle style={{ fontWeight: '700' }}>Product Review Form</NewsLetterStyle>
                            </div>
                            <div style={{color:'#FBBD34', backgroundColor:'#FBFFC8', padding:'1.5rem', textAlign:'justify'}}>Help other customers make informed decisions by sharing your insights. Please provide a detailed review of your experience with the product. Your feedback is invaluable to us!</div>
                            <div className='p-4'>
                                <LiveProdName style={{ fontWeight: '600' }}>Star Rating</LiveProdName>
                                <div className='mb-2' style={{display:'flex', flexDirection:'column', alignItems:'center'}}>
                                    {ratingOptions.map((rating) => (
                                        <div key={rating} style={{ marginBottom: '5px' }}>
                                            <Input
                                                type='radio'
                                                checked={selectedRating === rating}
                                                onChange={() => handleRatingChange(rating)}
                                            />{' '}
                                            &nbsp;
                                            <Rating
                                                readonly={true}
                                                initialRating={rating}
                                                emptySymbol={<Star size={20} fill='#babfc7' stroke='#babfc7' />}
                                                fullSymbol={<Star size={20} fill={themeColors.colors.warning.main} stroke={themeColors.colors.warning.main} />}
                                            />
                                        </div>
                                    ))}
                                </div>
                                <div className='mb-2'>
                                    <Label><LiveProdName style={{ fontWeight: '600' }}>Review</LiveProdName></Label>
                                    
                                    <Input type='textarea' value={reviewText} placeholder='Write your detailed review' onChange={(e) => setReviewText(e.target.value)} />
                                </div>
                                <div className='mb-2'>
                                <LiveProdName style={{ fontWeight: '600' }}>Add Photos</LiveProdName>
                                    <ImageFileUploader
                                        pictures={pictures}
                                        setPictures={setPictures}
                                        imgs={imgs}
                                        setImgs={setImgs}
                                        handleRemoveFile={(index) => handleRemoveFile(index, 'image')}
                                    />
                                </div>
                                <div className='mb-2'>
                                <LiveProdName style={{ fontWeight: '600' }}>Add Videos</LiveProdName>
                                    <ImageFileUploader
                                        pictures={videos}
                                        setPictures={setVideos}
                                        imgs={videoFiles}
                                        setImgs={setVideoFiles}
                                        handleRemoveFile={(index) => handleRemoveFile(index, 'video')}
                                    />
                                </div>
                                <div style={{display:'flex', justifyContent:'flex-end'}}>
                                    <button className='btn' color='primary' style={{backgroundColor:'#41B8E4', color:'white'}} onClick={onSubmit}>Submit Review</button>
                                </div>
                            </div>

                        </Card>
                        </Col>
                    </Row>
                </div>
                </Col>
            </Row>
        </div>
    )
}

export default ProductReviewForm
